/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolRamenDiningIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-ramen-dining"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M7.45 20.8Q4.88 19.77 3.17 17.63Q1.48 15.47 1.48 12.72Q1.48 12.18 1.86 11.79Q2.25 11.4 2.8 11.4L3.2 11.4L3.2 4.42Q3.2 3.92 3.55 3.54Q3.9 3.15 4.4 3.1L21.75 1.3Q22.18 1.25 22.49 1.54Q22.8 1.82 22.8 2.25Q22.8 2.6 22.55 2.86Q22.3 3.13 21.95 3.17L10.9 4.33L10.9 5.95L21.85 5.95Q22.25 5.95 22.52 6.22Q22.8 6.5 22.8 6.9Q22.8 7.3 22.52 7.58Q22.25 7.85 21.85 7.85L10.9 7.85L10.9 11.4L21.3 11.4Q21.85 11.4 22.24 11.79Q22.63 12.18 22.63 12.72Q22.63 15.47 20.91 17.63Q19.2 19.77 16.6 20.8L16.6 21.48Q16.6 22.02 16.21 22.41Q15.82 22.8 15.28 22.8L8.78 22.8Q8.22 22.8 7.84 22.41Q7.45 22.02 7.45 21.48ZM8 5.95L9 5.95L9 4.53L8 4.65ZM5.1 5.95L6.1 5.95L6.1 4.83L5.1 4.92ZM8 11.4L9 11.4L9 7.85L8 7.85ZM5.1 11.4L6.1 11.4L6.1 7.85L5.1 7.85Z" fill={color} />
    </svg>
  );
}
